import { http, HttpResponse } from 'msw'
import { StatusCodes } from 'http-status-codes'

import { allManagers } from 'app/mocks/data/park/managers'

import { api } from 'app/utils/constants'

import type { Supplier } from 'app/types/catalogue/supplier'
import { SupplierPayload } from 'app/types/catalogue/supplier'

export const createSupplier = http.post(
    `${process.env.REACT_APP_API_ADDRESS}/${api.catalogue.suppliers.LIST}`,
    async ({ request }) => {
        const payload = await request.json()
        const payloadParsed = SupplierPayload.safeParse(payload)

        // Wrong data
        if (!payloadParsed.success) {
            return HttpResponse.json(undefined, {
                status: StatusCodes.UNPROCESSABLE_ENTITY,
            })
        }

        return HttpResponse.json<Supplier>(
            {
                id: 999,
                ...payloadParsed.data,
                client: allManagers.find(
                    (manager) => manager.id === payloadParsed.data.client,
                ),
            },
            {
                status: StatusCodes.CREATED,
            },
        )
    },
)
